import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTwilioComponent } from './simple-icons-twilio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTwilioComponent ],
    exports:      [ SimpleIconsTwilioComponent ],
    bootstrap:    []
})
export class SimpleIconsTwilioModule {}
